<div class="header-grid">
    <div class="logo-container">
        <img src="../../../../assets/images/Ez-pins-logo.svg"/>
    </div>
</div>
